module.exports = __webpack_public_path__ + "img/google-pay.a7a6d2f4.svg";